import { render, staticRenderFns } from "./modalProductosInventario.vue?vue&type=template&id=389b79e4&"
import script from "./modalProductosInventario.vue?vue&type=script&lang=js&"
export * from "./modalProductosInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports